import { 
	ADD_FACULTY_STRUCTURE,
	ADD_FACULTY_STRUCTURE_ERROR,
	ADD_FACULTY_STRUCTURE_SUCCESS,
	ADD_SPECIALITY_STRUCTURE,
	ADD_SPECIALITY_STRUCTURE_ERROR,
	ADD_SPECIALITY_STRUCTURE_SUCCESS,
	ADD_UNIVERSITY_STRUCTURE,
	ADD_UNIVERSITY_STRUCTURE_ERROR,
	ADD_UNIVERSITY_STRUCTURE_SUCCESS,
	DELETE_FACULTY_STRUCTURE,
	DELETE_FACULTY_STRUCTURE_ERROR,
	DELETE_FACULTY_STRUCTURE_SUCCESS,
	DELETE_SPECIALITY_STRUCTURE,
	DELETE_SPECIALITY_STRUCTURE_ERROR,
	DELETE_SPECIALITY_STRUCTURE_SUCCESS,
	DELETE_UNIVERSITY_STRUCTURE,
	DELETE_UNIVERSITY_STRUCTURE_ERROR,
	DELETE_UNIVERSITY_STRUCTURE_SUCCESS,
	APPROVED_UNIVERSITY_STRUCTURE,
	APPROVED_UNIVERSITY_STRUCTURE_SUCCESS,
	APPROVED_UNIVERSITY_STRUCTURE_ERROR,
	APPROVED_FACULTY_STRUCTURE,
	APPROVED_FACULTY_STRUCTURE_SUCCESS,
	APPROVED_FACULTY_STRUCTURE_ERROR,
	APPROVED_SPECIALITY_STRUCTURE,
	APPROVED_SPECIALITY_STRUCTURE_SUCCESS,
	APPROVED_SPECIALITY_STRUCTURE_ERROR,
	EDIT_FACULTY_STRUCTURE,
	EDIT_FACULTY_STRUCTURE_ERROR,
	EDIT_FACULTY_STRUCTURE_SUCCESS,
	EDIT_SPECIALITY_STRUCTURE,
	EDIT_SPECIALITY_STRUCTURE_ERROR,
	EDIT_SPECIALITY_STRUCTURE_SUCCESS,
	EDIT_UNIVERSITY_STRUCTURE,
	EDIT_UNIVERSITY_STRUCTURE_ERROR,
	EDIT_UNIVERSITY_STRUCTURE_SUCCESS,
	GET_FACULTIES_STRUCTURES, 
	GET_FACULTIES_STRUCTURES_ERROR, 
	GET_FACULTIES_STRUCTURES_SUCCESS, 
	GET_SPECIALITIES_STRUCTURES, 
	GET_SPECIALITIES_STRUCTURES_ERROR, 
	GET_SPECIALITIES_STRUCTURES_SUCCESS, 
	GET_UNIVERSITIES_STRUCTURES, 
	GET_UNIVERSITIES_STRUCTURES_ERROR, 
	GET_UNIVERSITIES_STRUCTURES_SUCCESS 
} from "redux/constants/Structure"

const initState = {
	loading: false,
	specialities: [],
	faculties: [],
	universities: [],
	message: '',
}

const structure = (state = initState, action) => {
	switch (action.type) {
		case GET_UNIVERSITIES_STRUCTURES:
			return {
				...state,
				loading: true,
				universities: []
			}
		case GET_UNIVERSITIES_STRUCTURES_SUCCESS:
			return {
				...state,
				loading: false,
				universities: action.universities
			}
		case GET_UNIVERSITIES_STRUCTURES_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_UNIVERSITY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case ADD_UNIVERSITY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_UNIVERSITY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_UNIVERSITY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case EDIT_UNIVERSITY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_UNIVERSITY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case DELETE_UNIVERSITY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case DELETE_UNIVERSITY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case DELETE_UNIVERSITY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case APPROVED_UNIVERSITY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case APPROVED_UNIVERSITY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case APPROVED_UNIVERSITY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_FACULTIES_STRUCTURES:
			return {
				...state,
				loading: true,
				faculties: []
			}
		case GET_FACULTIES_STRUCTURES_SUCCESS:
			return {
				...state,
				loading: false,
				faculties: action.faculties
			}
		case GET_FACULTIES_STRUCTURES_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_FACULTY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case ADD_FACULTY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_FACULTY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_FACULTY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case EDIT_FACULTY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_FACULTY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case DELETE_FACULTY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case DELETE_FACULTY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case DELETE_FACULTY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case APPROVED_FACULTY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case APPROVED_FACULTY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case APPROVED_FACULTY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_SPECIALITIES_STRUCTURES:
			return {
				...state,
				loading: true,
				specialities: []
			}
		case GET_SPECIALITIES_STRUCTURES_SUCCESS:
			return {
				...state,
				loading: false,
				specialities: action.specialities
			}
		case GET_SPECIALITIES_STRUCTURES_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_SPECIALITY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case ADD_SPECIALITY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_SPECIALITY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_SPECIALITY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case EDIT_SPECIALITY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_SPECIALITY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case DELETE_SPECIALITY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case DELETE_SPECIALITY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case DELETE_SPECIALITY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case APPROVED_SPECIALITY_STRUCTURE:
			return {
				...state,
				loading: true,
			}
		case APPROVED_SPECIALITY_STRUCTURE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case APPROVED_SPECIALITY_STRUCTURE_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		default:
			return state;
	}
}

export default structure